import React, {Component} from 'react';

import formatters from "../../../../../utils/formatters";

export default class TripDispatch extends Component {

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;


        let load_datetime = ' - ';
        if(trip.load_datetime){
            load_datetime = formatters.datetimeFormat(trip.load_datetime);
        }

        let form = (
            <div>
                <div className={"row no-padding thin-row trip-form"}>
                    <div className={"col s6 no-padding"}>
                        <div className={"row margin-top-10 thin-row"}>
                            <div className={"col s6 input-field "}>
                                <label className="active">Fecha de Carga</label>
                                <p className={"field-p"}>{load_datetime}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Nro. Remito</label>
                                <p className={"field-p"}>{trip.provider_trip_receipt}</p>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field"}>
                                <label className="active">Producto</label>
                                <p className={"field-p"}>{trip.product.code}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Cantidad Despachada ({trip.product.origin_unit_of_measure}{trip.product.origin_density ? ` a ${trip.product.origin_density}º` : ""})</label>
                                <p className={"field-p"}>{formatters.intFormat(trip.provider_load_volume)}</p>
                            </div>
                        </div>
                    </div>
                    <div className={"col s6 no-padding"}>
                        <div className={"row margin-top-10 thin-row"}>
                            <div className={"col s12 input-field input-grey"}>
                                <label className="active">Observaciones</label>
                                <p className={"field-p truncate"}>{trip.provider_observations}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if(this.props.boxed){
            return (
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Despacho</div>
                    {form}
                </div>
            );
        }

        return form;
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Done/TripDispatch.js